const businessActivities = {
  Accommodations: {
    options: {
      'Casino hotel': {},
      Hotel: {},
      Motel: {},
      Other: {
        label: 'Other',
        specify: true,
        specifyPlaceholder: 'Type of accomodation',
      },
    },
  },
  Construction: {
    options: {
      Yes: {
        label: 'I focus on a single construction trade (concrete, framing, glass, etc.)',
        specify: true,
        specifyPlaceholder: 'What specific trade',
      },
      No: {
        label: 'I work on the whole project',
        options: {
          'I construct new residential properties': {},
          'I am involved in the remodeling of existing residential structures': {},
          'I construct non-residential properties (commercial, industrial)': {
            specify: true,
            specifyPlaceholder: 'Types of non-residential proprerties',
          },
          'I construct other types of structures (bridges, highways, water and sewer lines, pipeline, etc)': {
            specify: true,
            specifyPlaceholder: 'Types of structures',
          },
        },
      },
    },
  },
  Finance: {
    options: {
      'Commodities broker': {},
      'Credit Card issuing': {},
      'Investment Advice': {},
      'Investment Club': {},
      'Investment Holding': {},
      'Mortgage Broker - Agent for selling mortgages': {},
      'Mortgage Company - Lending funds with real estate as collateral': {},
      'Portfolio Management': {},
      'Sales Financing': {},
      'Securities Broker': {},
      'Trust Administration': {},
      'Venture Capital Company': {},
      'Other - please specify type of financial activity': {
        label: 'Other',
        specify: true,
        specifyPlaceholder: 'Type of financial activity',
      },
    },
  },
  'Food Service': {
    options: {
      Bar: {},
      'Bar and Restaurant': {},
      'Catering Service': {},
      'Coffee Shop': {},
      'Fast Food Restaurant': {},
      'Full Service Restaurant': {},
      'Ice Cream Shop': {},
      'Mobile Food Service': {},
      'Other - please specify type of food service': {
        label: 'Other',
        specify: true,
        specifyPlaceholder: 'Type of food service',
      },
    },
  },
  'Health Care': {
    options: {
      Yes: {
        label:
          'Includes medical practitioners having the degree of M.D. (Doctor of medicine) or D.O. (Doctor of osteopathy)',
        options: {
          'Medical doctor': {
            label: 'Primary business activity: Medical doctor',
          },
          Psychiatrist: {
            label: 'Primary business activity: Psychiatrist',
          },
          'Other mental health practitioner - please specify type': {
            label: 'Other mental health practitioner',
            specify: true,
            specifyPlaceholder: 'Type of practitioner',
          },
        },
      },
      No: {
        label: 'Does not include practitioners with those degress',
        options: {
          Chiropractor: {
            label: 'Primary business activity: Chiropractor',
          },
          Dentist: {
            label: 'Primary business activity: Dentist',
          },
          'HMO medical center': {
            label: 'Primary business activity: HMO medical center',
          },
          Hospital: {
            label: 'Primary business activity: Hospital',
          },
          Optometrist: {
            label: 'Primary business activity: Optometrist',
          },
          'Outpatient care center': {
            label: 'Primary business activity: Outpatient care center',
          },
          Podiatrist: {
            label: 'Primary business activity: Podiatrist',
          },
          Psychologist: {
            label: 'Primary business activity: Psychologist',
          },
          'Other mental health practitioner - please specify': {
            label: 'Primary business activity: Other mental health practitioner',
            specify: true,
            specifyPlaceholder: 'Type of mental health practitioner',
          },
          'Other - please specify': {
            label: 'Other',
            specify: true,
            specifyPlaceholder: 'Type of medical activity',
          },
        },
      },
    },
  },
  Insurance: {
    options: {
      'I am an insurance carrier': {},
      'I am an insurance agent or broker': {},
      'Other - please specify type of activity': {
        label: 'Other',
        specify: true,
        specifyPlaceholder: 'Type of activity',
      },
    },
  },
  Manufacturing: {
    specify: true,
    specifyPlaceholder: 'Type of goods you manufacture',
  },
  'Real Estate': {
    options: {
      'I rent or lease property that I own': {
        options: {
          'I rent residential real estate': {},
          'I rent commercial, industrial, or other real estate': {},
          'Other - please specify': {
            label: 'Other',
            specify: true,
            specifyPlaceholder: 'Type of rental or leased property',
          },
        },
      },
      'I use capital to build property': {
        options: {
          Yes: {
            label: 'I focus on a single construction trade',
            specify: true,
            specifyPlaceholder: 'Type of trade',
          },
          No: {
            label: 'I work on the entire project',
            options: {
              'I construct NEW residential properties (homes, condominiums, townhouses)': {},
              'I am involved in the remodeling of existing residential structures': {},
              'I construct non-residential properties (commercial, industrial). Please specify type of property constructed':
                {
                  label: 'I construct non-residential properties (commercial, industrial)',
                  specify: true,
                  specifyPlaceholder: 'Type of property constructed',
                },
              'I construct other types of structures (bridges, highways, water and sewer lines, pipeline, etc.). Please specify type of structure construted':
                {
                  label:
                    'I construct other types of structures (bridges, highways, water and sewer lines, pipeline, etc.)',
                  specify: true,
                  specifyPlaceholder: 'Type of structure constructed',
                },
            },
          },
        },
      },
      'I sell property for others': {},
      'I manage real estate for others': {},
      'Other - Please describe your primary real estate business': {
        label: 'Other',
        specify: true,
        specifyPlaceholder: 'Describe your primary real estate business',
      },
    },
  },
  'Rental & Leasing': {
    options: {
      'I rent, lease, or sell real estate': {
        options: {
          'I am a real estate agent - I do not own the structures that I rent or sell': {},
          'I rent residential real estate that I own': {},
          'I rent commercial, industrial, or other real estate that I own': {},
        },
      },
      'I rent or lease goods (specify goods)': {
        specify: true,
        specifyPlaceholder: 'Types of goods',
      },
      'I manage real estate for others': {},
    },
  },
  Retail: {
    options: {
      'Selling goods exclusively over the internet': {},
      'Sales from a storefront (please specify store type)': {
        label: 'Sales from a storefront',
        specify: true,
        specifyPlaceholder: 'Type of store',
      },
      'Direct Sales (Please specify method)': {
        label: 'Direct Sales',
        specify: true,
        specifyPlaceholder: 'Method of sales',
      },
      'Auction House': {},
      'Other (Please Specify)': {
        label: 'Other',
        specify: true,
        specifyPlaceholder: 'Specify',
      },
    },
  },
  'Social Assistance': {
    options: {
      'Nursing Home': {},
      Shelter: {},
      'Youth Services': {},
      'Other (Please Specify)': {
        label: 'Other',
        specify: true,
        specifyPlaceholder: 'Specify',
      },
    },
  },
  Transportation: {
    options: {
      Cargo: {
        options: {
          Air: {},
          Rail: {},
          Trucking: {},
          Water: {},
          'Other - please specify': {
            label: 'Other',
            specify: true,
            specifyPlaceholder: 'Type of cargo transport',
          },
        },
      },
      Passengers: {
        options: {
          'Limousine service': {},
          'Shuttle bus': {},
          'Taxi service': {},
          'Other - please specify': {
            label: 'Other',
            specify: true,
            specifyPlaceholder: 'Type of passenger transport',
          },
        },
      },
      'I provide a support activity for transportation (please specify)': {
        label: 'I provide a support activity for transportation',
        specify: true,
        specifyPlaceholder: 'Type of activity',
      },
    },
  },
  Warehousing: {},
  Wholesale: {
    options: {
      'Yes - please specify goods type': {
        label: 'I own or take title to the goods that I sell',
        specify: true,
        specifyPlaceholder: 'Types of goods',
      },
      No: {
        label: 'I do not own or take title to the goods that I sell',
        options: {
          Yes: {
            label: 'I receive a commission or fee from selling these goods',
          },
          'No. Please specify type of goods sold': {
            label: 'I do not receive a commission or fee from selling these goods',
            specify: true,
            specifyPlaceholder: 'Types of goods sold',
          },
        },
      },
    },
  },
  Other: {
    options: {
      Consulting: {
        options: {
          'Yes. Please specify type of consulting (for example, management, marketing, etc.)': {
            label: 'I provide operating advice and assistance to businesses and other organizations',
            specify: true,
            specifyPlaceholder: 'Type of consulting (for example, management, marketing, etc.)',
          },
          'No. Please specify your primary business activity': {
            label: 'I provide other types of advice',
            specify: true,
            specifyPlaceholder: 'Primary business activity',
          },
        },
      },
      Manufacturing: {
        specify: true,
        specifyPlaceholder: 'Type of goods and primary materials used (such as "wood furniture")',
      },
      Organization: {
        options: {
          'Athletic - please specify': {
            label: 'Athletic',
            specify: true,
            specifyPlaceholder: 'Primary activity',
          },
          'Conservation - please specify': {
            label: 'Conservation',
            specify: true,
            specifyPlaceholder: 'Primary activity',
          },
          'Environmental - please specify': {
            label: 'Environmental',
            specify: true,
            specifyPlaceholder: 'Primary activity',
          },
          'Fundraising - please specify': {
            label: 'Fundraising',
            specify: true,
            specifyPlaceholder: 'Primary activity',
          },
          'Homeowners association': {},
          'Religious - please specify': {
            label: 'Religious',
            specify: true,
            specifyPlaceholder: 'Primary activity',
          },
          'Social or civic - please specify': {
            label: 'Social or civic',
            specify: true,
            specifyPlaceholder: 'Primary activity',
          },
          'Other - please specify': {
            label: 'Other',
            specify: true,
            specifyPlaceholder: 'Primary activity',
          },
        },
      },
      Rental: {
        options: {
          'I rent, lease or sell real estate': {
            options: {
              'I am a real estate agent - I do not own the structures I rent or sell.': {},
              'I rent residential real estate that I own.': {},
              'I rent commercial, industrial, or other real estate that I own.': {},
            },
          },
          'I rent or lease goods. Please specify the type of goods': {
            label: 'I rent or lease goods',
            specify: true,
            specifyPlaceholder: 'Type of goods',
          },
        },
      },
      Repair: {
        specify: true,
        specifyPlaceholder: 'Type of goods you repair',
      },
      'Sell Goods': {
        options: {
          'Retail (I sell items directly to the general public. The sale of these items can be done from a storefront, over the Internet, by direct sales (catalogue, mail-order), or door-to-door. Also included are individuals that sell goods on Internet auction sites.)':
            {
              options: {
                'Selling goods exclusively over the Internet (includes independently selling on auction sites)': {},
                'Sales from a storefront. Please specify type of store': {
                  label: 'Sales from a storefront.',
                  specify: true,
                  specifyPlaceholder: 'Type of store',
                },
                'Direct sales. Please specify type of selling method (catalogue, mail order, door to door)': {
                  label: 'Direct sales',
                  specify: true,
                  specifyPlaceholder: 'Type of selling method (catalogue, mail order, door to door)',
                },
                'Auction house': {},
                'Other - please specify': {
                  label: 'Other',
                  specify: true,
                  specifyPlaceholder: 'Type of retail',
                },
              },
            },
          'Wholesale (I sell or arrange the purchase or sale of (a) goods for resale or to retailers, (b) capital or durable non-consumer goods (for example, commercial and manufacturing machinery, commercial aircraft), or (c) raw and intermediate materials and supplies used in production.)':
            {
              options: {
                'Yes. Please specify type of goods sold': {
                  label: 'I own or take title to the goods that I sell',
                  specify: true,
                  specifyPlaceholder: 'Type of goods',
                },
                No: {
                  label: 'I do not own or take title to the goods that I sell',
                  options: {
                    Yes: {
                      label: 'I receive a commission or fee from selling these goods',
                    },
                    'No - Please specify type of goods sold': {
                      label: 'I do not receive a commission or fee for selling these goods',
                      specify: true,
                      specifyPlaceholder: 'Type of goods sold',
                    },
                  },
                },
              },
            },
        },
      },
      Service: {
        specify: true,
        specifyPlaceholder: 'Primary service you provide',
      },
      'Other (Please Specify)': {
        label: 'Other',
        specify: true,
        specifyPlaceholder: 'Specify',
      },
    },
  },
};

const getActivities = (level1, level2, level3, level4, level5, specify) => {
  const activity1 = level1 ? businessActivities[level1] : null;
  const activity2 = activity1 && activity1.options ? activity1.options[level2] || null : null;
  const activity3 = activity2 && activity2.options ? activity2.options[level3] || null : null;
  const activity4 = activity3 && activity3.options ? activity3.options[level4] || null : null;
  const activity5 = activity4 && activity4.options ? activity4.options[level5] || null : null;
  const label1 = activity1 ? activity1.label || level1 : '';
  const label2 = activity2 ? activity2.label || level2 : null;
  const label3 = activity3 ? activity3.label || level3 : null;
  const label4 = activity4 ? activity4.label || level4 : null;
  const label5 = activity5 ? activity5.label || level5 : null;
  return [label1, label2, label3, label4, label5, specify].filter((label) => !!label && label !== '');
};

export default getActivities;
